//React
import React from "react";
import {
  NavLink,
} from "react-router-dom";

//Icon
import ChatIcon from '@material-ui/icons/Chat';
import HelpIcon from '@material-ui/icons/Help';
import LabelIcon from '@material-ui/icons/Label';

class Comp extends React.Component {
  render() {
    return (
      <div className='sub_menu'>
        <div className='outer'>
            <NavLink to="/community/post/" exact className='link' activeClassName="selected">
              <ChatIcon className='icon' /><div className='text'>投稿</div>
            </NavLink>
            <NavLink to="/community/qa/" className='link' activeClassName="selected">
              <HelpIcon className='icon' /><div className='text'>Q&A</div>
            </NavLink>
            <NavLink to="/community/keyword/" className='link' activeClassName="selected" style={{display:'block'}}>
              <LabelIcon className='icon' /><div className='text'>キーワード</div>
            </NavLink>
        </div>
      </div>
    )
  }
}
/*


*/

export default Comp;
